import React, { useMemo } from 'react'
import cx from 'classnames'

import styles from './IgnoredSectionEditor.module.scss'

import CheckboxTree, { toTree } from 'Design/components/CheckboxTree'

const IngoredSectionsEditor = (props) => {
  const { sections = [], value: ignoredSections, onChange, isLoading } = props
  const sectionsTree = useMemo(() => toTree(sections), [sections])

  return (
    <div className={cx(styles.TreeContainer, { [styles.Loading]: isLoading })}>
      {isLoading && 'Loading sections. This might take a while. Please wait'}
      {!isLoading && <CheckboxTree nodes={sectionsTree} checked={ignoredSections} onChange={onChange} />}
    </div>
  )
}

export default IngoredSectionsEditor
